<template>
  <vue-dialog :dialog-data="dialogData" @confirm="confirm">
    <el-form :model="form" label-width="auto" :rules="rules" ref="form" size="small">
      <el-form-item label="批次编号" prop="batch_no">
        <device-batch-select v-model="form.batch_no" filterable/>
      </el-form-item>
    </el-form>
  </vue-dialog>
</template>

<script>
  import {inputEmpty} from "@utils/validate"
  import DeviceBatchSelect from "@view/components/select/DeviceBatchSelect"
  export default {
    name: "DeleteBatchNo",
    components: {DeviceBatchSelect},
    props: {dialogData: Object},
    data() {
      return {
        total: 0,
        form: {batch_no: ""},
        rules: {batch_no: [inputEmpty("批次编号")]},
      }
    },
    methods: {
      confirm() {
        this.$refs["form"].validate(async isOk => {
          if (isOk) {
            await this.getTableList();
            let msg = `
              <p>删除批次：<span class="color-danger">${this.form.batch_no}</span></p>
              <p>批次个数：<span class="color-danger">${this.total}</span></p>
              确定要删除该批次吗？
            `;
            this.openConfirm(msg, async () => {
              let nv = {
                type: "batch",
                ...this.form
              };
              let res = await this.$Http.deleteDevice(nv);
              if (res) {
                this.msgSuccess("删除成功");
                this.$emit("table-reload");
                this.dialogData.visible = false;
              }
            }, {dangerouslyUseHTMLString: true}, true);
          }
        });
      },
      async getTableList() {
        let nv = {batch_no: this.form.batch_no};
        let res = await this.$Http.getDeviceCustom(nv);
        if (res?.data) {
          this.total = +res.data.total || 0;
        }
      },
    }
  }
</script>

<style scoped>

</style>
